import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().optional(), // Optional for global themes
  themeDescription: z.string().min(10).max(1000), // Description of the theme for context
  style: z
    .enum(['photorealistic', 'illustration', 'abstract', 'minimalist', 'artistic', 'cinematic'])
    .optional()
    .default('photorealistic'),
  mood: z
    .enum(['professional', 'playful', 'elegant', 'modern', 'vintage', 'futuristic', 'natural'])
    .optional(),
  elements: z.string().optional(), // Specific elements to include (e.g., "geometric shapes", "nature")
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  imagePrompt: string;
  suggestions?: string[]; // Alternative prompts
};

export const generateImagePrompt = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const result = await fetch('/_api/themes/generate-image-prompt', {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    body: superjson.stringify(input),
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
